import { MainLayout } from '../../../core/layouts/MainLayout';
import { PageRenderer } from '../../landing/components/PageRenderer';

export const ExplorePage = () => {
    return (
        <MainLayout forceSolidNavbar>
            <div className="pt-16 sm:pt-20">
                <PageRenderer slug="explore" />
            </div>
        </MainLayout>
    );
};
